import { COMPUTER_COMMAND_QUERY_UPDATE_TAG } from '#pplx/frontend/components/form/lexical/plugins/ComputerCommandQueryPlugin.js';
export const EXTERNAL_UPDATE_TAG = 'external-update';
export const FOCUS_TAG = 'focus';
export const BLUR_TAG = 'blur';
export const SLASH_HINT_UPDATE_TAG = 'slash-hint-update';
export const TAGS_TO_IGNORE = new Set([
    EXTERNAL_UPDATE_TAG,
    FOCUS_TAG,
    BLUR_TAG,
    COMPUTER_COMMAND_QUERY_UPDATE_TAG,
    SLASH_HINT_UPDATE_TAG,
]);
//# sourceMappingURL=constants.js.map